import { render, staticRenderFns } from "./AwardWinnerSection.vue?vue&type=template&id=37ad20ba&scoped=true"
import script from "./AwardWinnerSection.vue?vue&type=script&lang=ts"
export * from "./AwardWinnerSection.vue?vue&type=script&lang=ts"
import style0 from "./AwardWinnerSection.vue?vue&type=style&index=0&id=37ad20ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ad20ba",
  null
  
)

export default component.exports